import { useMemo } from "react";

import { SourceType } from "@/apollo/types";
import { useSearchSyncDestinations } from "@/entities/elt";
import { formatModelName, useModelSearch } from "@/features/models";

import { SourceOption } from "../ui/components/SourceSelector";

export function useSourceSearch(query: string) {
  const trimmedQuery = query.trim().replace(/[\s.]+$/, ""); // Remove trailing spaces and dots

  const modelResults = useModelSearch(trimmedQuery, {
    publishedOnly: true,
  });

  const viewResults = useSearchSyncDestinations(trimmedQuery);

  const isSearching = modelResults.isSearching || viewResults.isSearching;
  return useMemo(() => {
    const modelOptions = modelResults.models.map(
      (model): SourceOption => ({
        label: formatModelName(model),
        value: model.id,
        data: model,
        type: SourceType.Model,
      }),
    );

    const viewOptions = viewResults.syncDestinations.map(
      (view): SourceOption => ({
        label: `${view.schemaName}.${view.name}`,
        value: view.viewId,
        data: view,
        type: SourceType.RawView,
      }),
    );

    const results: SourceOption[] = [...modelOptions, ...viewOptions];

    return {
      options: results.sort((a, b) => a.label.localeCompare(b.label)),
      isSearching,
    };
  }, [modelResults.models, viewResults.syncDestinations, isSearching]);
}
